export default __webpack_public_path__ + "static/media/gitfusion-4.9371bd63.jpg";